import LinkSvg from '@/shared/assets/images/Link.svg'
import { FC } from 'react'

interface CopyButtonProps {
    onClick: () => void
}

export const CopyButton: FC<CopyButtonProps> = ({ onClick }) => {
    return (
        <button onClick={onClick}>
            <LinkSvg width={24} height={24}/>
        </button>
    )
}